export const NOTES_INPUT_ROWS = 4;

export const TEST_ID = 'notesInput';
